export default __webpack_public_path__ + "static/media/coursera.c66dd69b.png";